import { jsx as e, jsxs as m, Fragment as A } from "react/jsx-runtime";
import * as t from "react";
import { cn as p } from "../../../lib/utils.js";
import { AppRail as R } from "../app-rail/AppRail.js";
import { AppSidebar as B } from "../app-sidebar/AppSidebar.js";
import { BottomNavigation as H } from "../bottom-navigation/BottomNav.js";
import { Sheet as J, SheetContent as O } from "../sheet/Sheet.js";
import { motion as E, AnimatePresence as Q } from "framer-motion";
import { Menu as W } from "lucide-react";
const P = t.createContext(null), se = () => {
  const s = t.useContext(P);
  if (!s)
    throw new Error("useAppShell must be used within an AppShell");
  return s;
}, X = () => {
  const [s, a] = t.useState(() => {
    if (typeof window > "u")
      return "wide";
    const i = window.innerWidth;
    return i < 768 ? "mobile" : i < 1024 ? "tablet" : i < 1280 ? "desktop" : "wide";
  });
  return t.useEffect(() => {
    const i = () => {
      const l = window.innerWidth;
      l < 768 ? a("mobile") : l < 1024 ? a("tablet") : l < 1280 ? a("desktop") : a("wide");
    };
    return window.addEventListener("resize", i), i(), () => window.removeEventListener("resize", i);
  }, []), s;
}, Y = t.forwardRef(({ apps: s, activeApp: a, onAppChange: i, sidebarNavigation: l, header: o, children: N, userAvatar: M, onSettingsClick: z, onUserClick: K, onSearchOpen: w, className: T }, V) => {
  const v = X(), f = v === "mobile", u = v === "tablet", x = v === "desktop", S = v === "wide", [c, L] = t.useState(a), [d, k] = t.useState(x), [F, y] = t.useState(!1);
  t.useEffect(() => {
    L(a);
  }, [a]), t.useEffect(() => {
    x ? k(!0) : S && k(!1);
  }, [x, S]);
  const b = t.useCallback((n) => {
    L(n), i == null || i(n);
  }, [i]), h = t.useCallback(() => {
    k((n) => !n);
  }, []), g = t.useCallback(() => {
    w == null || w();
  }, [w]), C = t.useCallback(() => {
    y(!0);
  }, []), j = t.useCallback(() => {
    y(!1);
  }, []);
  t.useEffect(() => {
    const n = (r) => {
      (r.metaKey || r.ctrlKey) && r.key === "k" && (r.preventDefault(), g()), (r.metaKey || r.ctrlKey) && r.key === "b" && (r.preventDefault(), u ? y((G) => !G) : f || h());
    };
    return window.addEventListener("keydown", n), () => window.removeEventListener("keydown", n);
  }, [g, h, f, u]);
  const D = s.find((n) => n.id === c) || s[0], U = t.useMemo(() => ({
    activeApp: c,
    sidebarCollapsed: d,
    isMobile: f,
    isTablet: u,
    setActiveApp: b,
    toggleSidebar: h,
    openSearch: g,
    openMobileSidebar: C,
    closeMobileSidebar: j
  }), [c, d, f, u, b, h, g, C, j]), q = t.useMemo(() => s.map((n) => ({
    ...n,
    badge: n.badge
  })), [s]);
  return e(P.Provider, { value: U, children: m("div", { ref: V, className: p("min-h-screen bg-bg-primary", T), children: [f && m(A, { children: [o && e("div", { className: "fixed top-0 left-0 right-0 z-40", children: o }), e("main", { className: p(
    "pb-20",
    // Space for bottom nav
    o && "pt-14"
    // Space for header (h-14 = 56px)
  ), children: N }), e(H, { apps: q, activeApp: c, onAppChange: b, maxVisibleTabs: 4, showMoreMenu: !0 })] }), u && m(A, { children: [e(R, { apps: s, activeApp: c, onAppChange: b, userAvatar: M, onSettingsClick: z, onUserClick: K }), o && m("div", { className: "fixed top-0 left-16 right-0 z-30 flex items-center", children: [e("button", { onClick: C, className: p("h-14 px-4 flex items-center justify-center", "text-text-secondary hover:text-text-primary", "hover:bg-border-color/50 transition-colors"), "aria-label": "Open navigation menu", children: e(W, { className: "w-5 h-5" }) }), e("div", { className: "flex-1", children: o })] }), e("main", { className: p("ml-16", o && "pt-14"), children: N }), e(J, { open: F, onOpenChange: y, children: e(O, { side: "left", className: "w-60 p-0", children: e(B, { app: D, navigation: l, collapsed: !1 }) }) })] }), (x || S) && m(A, { children: [e(R, { apps: s, activeApp: c, onAppChange: b, userAvatar: M, onSettingsClick: z, onUserClick: K }), e("div", { className: "fixed left-16 top-0 bottom-0 z-30", children: e(B, { app: D, navigation: l, collapsed: d, onCollapsedChange: k }) }), o && m(E.div, { className: "fixed top-0 right-0 z-30 flex items-center", initial: !1, animate: {
    left: d ? 64 : 284
  }, transition: { duration: 0.3, ease: [0.4, 0, 0.2, 1] }, children: [e(Q, { children: d && e(E.button, { initial: { opacity: 0, width: 0 }, animate: { opacity: 1, width: "auto" }, exit: { opacity: 0, width: 0 }, transition: { duration: 0.2 }, onClick: h, className: p("h-14 px-4 flex items-center justify-center", "text-text-secondary hover:text-text-primary", "hover:bg-border-color/50 transition-colors"), "aria-label": "Open sidebar", children: e(W, { className: "w-5 h-5" }) }) }), e("div", { className: "flex-1", children: o })] }), e(E.main, { initial: !1, animate: {
    marginLeft: d ? 64 : 284
  }, transition: { duration: 0.3, ease: [0.4, 0, 0.2, 1] }, className: p(o && "pt-14"), children: N })] })] }) });
});
Y.displayName = "AppShell";
export {
  Y as AppShell,
  se as useAppShell
};
//# sourceMappingURL=AppShell.js.map
